import React from 'react';

import styled from './PageLoaderStyles';

const PageLoader = ({ size, color, ...props }) => (
	<styled.Wrapper>
		<styled.Loader size={size} {...props}>
			<styled.Circular viewBox="25 25 50 50">
				<styled.Path
					color={color}
					cx="50"
					cy="50"
					r="20"
					fill="none"
					stroke-width="6"
					stroke-miterlimit="10"
				/>
			</styled.Circular>
		</styled.Loader>
	</styled.Wrapper>
);

export default PageLoader;
